import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isMarkActive, toggleMarkCommand } from '../utils/markUtils';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { Tracker } from '../../utils/usageTracker';
import { PM_FORMATTING } from '../constants/events';
import { CHANGE_INLINE_STYLE } from 'rich-text-lib/constants/usageTracking';
import { ItalicIcon } from 'foundations-assets/icons/components/ItalicIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const toggleItalic = toggleMarkCommand(schema => schema.marks.em);
export default function ItalicMark() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const toggleItalicMark = useCallback(e => {
    e.preventDefault();
    toggleItalic(editorState, tr => setEditorState(editorState.apply(tr)));
    Tracker.track(PM_FORMATTING, {
      action: CHANGE_INLINE_STYLE,
      method: 'toolbar',
      value: 'italic'
    });
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.italic"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      onMouseDown: toggleItalicMark,
      "data-test-id": "italic",
      "aria-label": I18n.text('hubspot-prosemirror.tooltips.italic'),
      selected: editorState && isItalic(editorState),
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: ItalicIcon
      })
    })
  });
}
function isItalic(state) {
  return isMarkActive(state, state.schema.marks.em);
}